const getFormattedId = (linkLabel) =>
  linkLabel
    .toLowerCase()
    .replace(/[?.]/g, '')
    .replace(/ [&/] | /g, '-');

export default getFormattedId;
